import React from "react";
import { SwipeableDrawer, Box, useTheme, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLeftBar } from "../../context/LeftBar";
import NavItem from "./MenuItem/NavItem";

const MobileDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "100%",
    maxWidth: "100%",
    background: theme.palette.background.default,
    top: "64px",
    height: "calc(100% - 64px)",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
    boxShadow: "none",
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
  },
}));

function MobileMenu({ menuItems }) {
  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleNavigation = () => {
    setLeftBarOpened(false);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setLeftBarOpened(open);
  };

  if (!isMobile) return null;

  return (
    <MobileDrawer
      anchor="left"
      open={leftBarOpened}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      swipeAreaWidth={30}
    >
      <Box
        sx={{
          p: 2,
          height: "100%",
          overflowY: "auto",
          "& .navItem": {
            marginBottom: 1,
            "& a": {
              padding: "16px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              gap: 2,
              color: "red",
              "&.active": {
                backgroundColor: "#000B72",
                color: "#fff !important",
                "& .navItemName": {
                  color: "#fff !important",
                },
                "& svg": {
                  color: "#fff !important",
                },
              },
            },
          },
          "& .leftSideContentTitle": {
            fontSize: "14px",
            color: "#666",
            padding: "24px 8px 12px",
            margin: 0,
            fontWeight: 500,
          },
          "& .navItemName": {
            fontSize: "16px",
          },
          "& svg": {
            fontSize: "24px",
          },
        }}
      >
        <div className="leftSideContent">
          <ul>
            {menuItems.slice(0, 1).map((item) => (
              <NavItem key={item.id} {...item} onClick={handleNavigation} hideIcon />
            ))}
          </ul>
          <ul>
            {menuItems.slice(1, 5).map((item) => (
              <NavItem key={item.id} {...item} onClick={handleNavigation} hideIcon />
            ))}
          </ul>

          <h3 className="leftSideContentTitle">AJUDA</h3>
          <ul>
            {menuItems.slice(5, 7).map((item) => {
              return (
                <NavItem key={item.id} {...item} onClick={handleNavigation} hideIcon/>
              );
            })}
          </ul>
        </div>
      </Box>
    </MobileDrawer>
  );
}

export default MobileMenu;
